import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import styles from './styles.module.scss'
import Location from 'srcReact/GroupPage/CreateUpdateGroup/components/Location'
import DescriptionTextArea from 'srcReact/GroupPage/CreateUpdateGroup/components/DescriptionTextArea'
import Icon from 'srcReact/components/icons/Icon'
import AdvanceSettings from 'srcReact/GroupPage/CreateUpdateGroup/components/AdvanceSettings'
import PrivacySetting from 'srcReact/GroupPage/CreateUpdateGroup/components/PrivacySetting'
import GroupName from 'srcReact/GroupPage/CreateUpdateGroup/components/GroupName'
import { decode } from 'html-entities/lib/index'
import GroupPicture from './components/GroupPicture'
import GroupInterests from './components/GroupInterests'
import Modal from 'srcReact/components/common2/Modal'
import ServerErrors from 'srcReact/components/popinsContent/ServerErrors'
import Link from 'react-router-dom/Link'
import { alertActions, AlertContainer } from 'srcReact/Alert'
import { commonActions } from 'srcReact/components'
import { createUpdateGroupActions } from './actions'

const EditGroup = (props) => {
  const { t } = useTranslation()
  const [formValidationErrors, setFormValidationErrors] = useState([])
  const [showErrorPopup, setShowErrorPopup] = useState(false)
  const dispatch = useDispatch()
  const {
    alert,
    createUpdateGroup: { groupName, isGeneralGroup, groupInfo, updateGroupErrors }
  } = useSelector((state) => state)

  useEffect(() => {
    dispatch(createUpdateGroupActions.getGroupDetailById(props.match.params.groupId))
  }, [dispatch])
  useEffect(() => {
    const pathname = props.location.pathname
    if (pathname.includes('settings')) {
      const settingElement = document.getElementById('groupAdvanceSettings')
      if (settingElement) {
        setTimeout(() => settingElement.scrollIntoView(true, { behavior: 'smooth' }), 1000)
      }
    }
    return () => {
      dispatch(createUpdateGroupActions.clearData())
      dispatch(commonActions.updateSelectedInterests([]))
      dispatch(commonActions.fileCreationRemove())
    }
  }, [])

  useEffect(() => {
    if (updateGroupErrors && updateGroupErrors.length > 0) {
      setShowErrorPopup(true)
    } else {
      setShowErrorPopup(false)
    }
  }, [updateGroupErrors])

  useEffect(() => {
    if (groupInfo) {
      if (groupInfo.is_general === 1) {
        dispatch(createUpdateGroupActions.setAsGeneralGroup())
      }
      dispatch(
        createUpdateGroupActions.setGroupName({
          name: 'groupName',
          value: groupInfo.name,
          hasError: false,
          errorMessage: '',
          isRequired: true
        })
      )
      dispatch(createUpdateGroupActions.setGroupPicture(groupInfo.picture))
      dispatch(
        createUpdateGroupActions.setDescription({
          name: 'groupDescription',
          value: groupInfo.description,
          hasError: false,
          errorMessage: '',
          isRequired: true
        })
      )
      dispatch(
        createUpdateGroupActions.setLocation({
          value: groupInfo.location,
          hasError: false,
          errorMessage: '',
          isRequired: true
        })
      )

      dispatch(createUpdateGroupActions.addSelectedInterests(groupInfo.interests || groupInfo.expertises))
      dispatch(createUpdateGroupActions.setGroupType(groupInfo.group_type))
      dispatch(createUpdateGroupActions.setPrivacySetting(groupInfo.privacy_setting))
      dispatch(createUpdateGroupActions.setMixrSetting(groupInfo.members_can_suggest_mixr))
      dispatch(createUpdateGroupActions.setAdmissionSetting(groupInfo.automatic_approval_to_join))
      dispatch(
        createUpdateGroupActions.setMemberSetting({
          age: groupInfo.age_requirements
        })
      )
    }
  }, [groupInfo])

  const closeErrorPopup = () => {
    setShowErrorPopup(false)
  }

  return (
    <PageContainer pageClassName={styles.pageContainer} pageTitle={t('group.editGroup.title')} withFooter={false}>
      {alert && alert.message ? (
        <AlertContainer
          title={t('error.error_alert_title')}
          message={alert.message}
          show={!!alert.message}
          handleClose={() => dispatch(alertActions.clear())}
        />
      ) : null}
      <div className={styles.headerContainer}>
        {groupName && groupName.value && (
          <Link className={styles.backUrl} to={`/0/home/group/${props.match.params.groupId}`}>
            <Icon styleModifier={styles.backIcon} name='arrow-left24' />
            <span>{decode(groupName.value)}</span>
          </Link>
        )}
      </div>

      <div className={`${styles.container} ${styles.editContainer}`}>
        {isGeneralGroup ? (
          <h1 className={styles.title}>{t('group.editGroup.generalGroupTitle')}</h1>
        ) : (
          <h1 className={styles.title}>{t('group.editGroup.title')}</h1>
        )}
        <div className={styles.parentContainer}>
          <GroupName
            containerCss={styles.subContainer}
            innerContainerCss={styles.content}
            infoCss={styles.para}
            titleCss={styles.subTitle}
            buttonWrapperCss={styles.buttonWrapper}
            verticalLineCss={styles.verticalLine}
            editMode={true}
          />
          <GroupPicture
            show={true}
            containerCss={styles.subContainer}
            innerContainerCss={styles.content}
            infoCss={styles.para}
            titleCss={styles.subTitle}
            buttonWrapperCss={styles.buttonWrapper}
            verticalLineCss={styles.verticalLine}
            editMode={true}
          />
          <DescriptionTextArea
            show={true}
            containerCss={styles.subContainer}
            innerContainerCss={styles.content}
            infoCss={styles.para}
            titleCss={styles.subTitle}
            buttonWrapperCss={styles.buttonWrapper}
            verticalLineCss={styles.verticalLine}
            editMode={true}
          />
          <GroupInterests
            show={!isGeneralGroup}
            containerCss={styles.subContainer}
            innerContainerCss={styles.content}
            infoCss={styles.para}
            titleCss={styles.subTitle}
            buttonWrapperCss={styles.buttonWrapper}
            verticalLineCss={styles.verticalLine}
            editMode={true}
          />
          <Location
            show={!isGeneralGroup}
            containerCss={styles.subContainer}
            innerContainerCss={styles.content}
            infoCss={styles.para}
            titleCss={styles.subTitle}
            buttonWrapperCss={styles.buttonWrapper}
            verticalLineCss={styles.verticalLine}
            editMode={true}
          />
          <PrivacySetting
            show={groupInfo && groupInfo.privacy_setting_editable === 1 && !isGeneralGroup}
            containerCss={styles.subContainer}
            innerContainerCss={styles.content}
            infoCss={styles.para}
            titleCss={styles.subTitle}
            buttonWrapperCss={styles.buttonWrapper}
            verticalLineCss={styles.verticalLine}
            editMode={true}
          />
          <div className={`${styles.subContainer}  ${styles.lastSubContainer}  ${styles.show}`}>
            <div class={`${styles.verticalLine} ${styles.lastVerticalLine}`} />
            <AdvanceSettings
              show={true}
              hasMemberSetting={isGeneralGroup ? false : true}
              hasMixrSetting={true}
              hasAdmission={isGeneralGroup ? false : true}
              containerCss={styles.subContainer}
              innerContainerCss={styles.content}
              infoCss={styles.para}
              buttonWrapperCss={styles.buttonWrapper}
              verticalLineCss={styles.verticalLine}
              editMode={true}
              routeProps={props}
            />
          </div>
        </div>
      </div>
      {showErrorPopup && (
        <Modal isOpen={showErrorPopup} handleClose={closeErrorPopup}>
          <ServerErrors
            errors={updateGroupErrors}
            title={t('group.editGroup.serverErrorTitleUpdate')}
            closeModal={closeErrorPopup}
          />
        </Modal>
      )}
    </PageContainer>
  )
}

export default EditGroup
